/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnerDraftsControllerStartOwnerMutationResponse, OwnerDraftsControllerStartOwnerPathParams, OwnerDraftsControllerStartOwner400, OwnerDraftsControllerStartOwner401, OwnerDraftsControllerStartOwner403 } from "../../models/ownerDraftsController/OwnerDraftsControllerStartOwner";

function getOwnerDraftsControllerStartOwnerUrl(id: OwnerDraftsControllerStartOwnerPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/document-drafts/owner/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/owner/:id}
 */
export async function ownerDraftsControllerStartOwner(id: OwnerDraftsControllerStartOwnerPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OwnerDraftsControllerStartOwnerMutationResponse, ResponseErrorConfig<OwnerDraftsControllerStartOwner400 | OwnerDraftsControllerStartOwner401 | OwnerDraftsControllerStartOwner403>, unknown>({ method : "POST", url : getOwnerDraftsControllerStartOwnerUrl(id).url.toString(), ... requestConfig })  
  return res.data
}